import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { UserAddress } from '../types/user-address';
import type { GetPlaceUseCase } from './use-cases/get-place.usecase';

type UseCaseInput = {
  latitude: number | null;
  longitude: number | null;
};

type UseCaseOutput = UserAddress;

export class ConvertCoordinatesToAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private getPlaceUseCase: GetPlaceUseCase;

  constructor(getPlaceUseCase: GetPlaceUseCase) {
    this.getPlaceUseCase = getPlaceUseCase;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { latitude, longitude } = input;

    if (!latitude || !longitude) {
      throw new Error('Latitude e longitude são obrigatórias');
    }

    const place = await this.getPlaceUseCase.execute({
      lat: latitude,
      lon: longitude,
    });

    return {
      id: 'geolocation',
      street: place.street || '',
      city: place.city || '',
      state: place.state || '',
      coordinates: {
        latitude: latitude,
        longitude: longitude,
      },
      complement: '',
      district: place.district || '',
      cep: place.cep || '',
      number: place.number || 'S/N',
      reference: '',
    };
  }
}
